import React 			from 'react';
import ReactDOM 	from 'react-dom';
import PropTypes 	from 'prop-types';
import Slider			from 'react-slick';

import BLComponent 	from '../core/_BLComponent.jsx';

import FloatingImage 	from './_FloatingImage.jsx';
import LikeButton 		from './_LikeButton.jsx';
import ZoomModal 			from '../modals/_ZoomModal.jsx';
import Part3DViewer		from './_Part3DViewer.jsx';

const PrevArrow = ({currentSlide, slideCount, children, ...props}) => (
	<button {...props}><i className="fas fa-chevron-left"></i></button>
);

const NextArrow = ({currentSlide, slideCount, children, ...props}) => (
	<button {...props}><i className="fas fa-chevron-right"></i></button>
);

export default class GalleryCard extends BLComponent 
{
	constructor( props, context ) 
	{
		super( props, context );

		this.state = {
			activeImage: this.props.active ? this.props.active : 0	
		,	wantedListEnabled:	( props.wantedList && props.wantedList.enabled )
		,	isWanted:			( props.wantedList && props.wantedList.isWanted )
		,	wantedCnt:			( props.wantedList && props.wantedList.wantedCount ) ? props.wantedList.wantedCount : 0
		};

		this.slickSettings = {
			dots: false,
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			prevArrow: <PrevArrow />,
			nextArrow: <NextArrow />,
			afterChange: (index) => this.changeSlide(index)
		}
	}

	static getDerivedStateFromProps( nextProps, prevState ) 
	{
		prevState.wantedListEnabled	= ( nextProps.wantedList && nextProps.wantedList.enabled );
		return prevState;
	}	

	componentDidMount() 
	{
		this.fetchPersonalizeData();
	
		this.preloadMain();

		if(this.props.hasBgColor) {
			this.getBgColor(this.props.images[0].large);
		}
	}

	preloadMain() {
		const images = this.props.images;
		const mainImage = images[0].large;

		const preload = document.createElement("link");
					preload.href = mainImage;
					preload.rel = "preload";
					preload.as = "image";

		document.head.appendChild(preload);
	}

	componentWillUnmount() 
	{ 
		super.componentWillUnmount(); 
		if ( this._callbackRegistered != null )
			blapp.personalized.unregisterCallback( this._callbackRegistered );
	}

	componentDidUpdate( prevProps, prevState, snapshot ) 
	{ 
		super.componentDidUpdate( prevProps, prevState, snapshot ); 

		if ( ( prevState.wantedListEnabled != this.state.wantedListEnabled
				|| ( prevProps.item && prevProps.item.idItem != this.props.item.idItem )
				|| ( prevProps.item && prevProps.item.idColor != this.props.item.idColor ) )
			&& ( this.state.wantedListEnabled ) )
		{
			blapp.personalized.fetchWantedPrefData( this.props.item.idItem, this.props.item.idColor, this.updatePersonalizedData );
		}

		if(this.state.activeImage != '3d' && (( prevProps.item && prevProps.item.idItem != this.props.item.idItem )
		|| ( prevProps.item && prevProps.item.idColor != this.props.item.idColor ) ))
		{
			this.setState({activeImage:0})
		}


		if(this.props.hasBgColor) {
			if(prevState.activeImage != this.state.activeImage) {
				this.getBgColor(this.props.images[this.state.activeImage].large);
			}
		}
	}	

	getBgColor = (imageUrl) => {
		var canvas = document.createElement("canvas");
		var context = canvas.getContext('2d');
		var myImg = new Image();
		myImg.crossOrigin = "Anonymous";
		myImg.src = imageUrl;
		myImg.onload = () => {
			context.drawImage(myImg, 0, 0);
			var c = context.getImageData(0, 0, 1, 1).data;
			var hex = "#" + ("000000" + this.rgbToHex(c[0], c[1], c[2])).slice(-6);
			this.setState({bgColor: hex})
		}
	}

	rgbToHex = (r, g, b) => {
		if (r > 255 || g > 255 || b > 255)
			throw "Invalid color component";
		return ((r << 16) | (g << 8) | b).toString(16);
	}

	render() {
		const {classes = '', active, images, wanted, renderingData, verticalThumbs = false, mode = 0, hasBgColor = false} = this.props;

		const wantedListEnabled 	= this.state.wantedListEnabled;
		const wantedListIsWanted 	= this.state.isWanted;
		const wantedListCount 		= this.state.wantedCnt;

		let activeImage = images.findIndex(image => image.id == this.state.activeImage);
		if(this.state.activeImage != '3d'){
			activeImage = images[activeImage] ? images[activeImage].large : blapp.url2.getNoImageUrl();
		}

		return (
			<article className={"gallery-card " + classes + (verticalThumbs ? ' gallery-card--vertical-thumbs' : '')}>
				{this.state.showZoomModal ? this.renderZoomModal() : null}
				<div className={"gallery-card__main" + (this.props.mode === 1 ? ' l-block' : '') + (hasBgColor ? ' gallery-card__main--with-bg-color' : '')} style={{backgroundColor: hasBgColor ? this.state.bgColor : ''}}>
					{this.props.mode === 1 ?
						<React.Fragment>
							<Slider ref={slider => this.slider = slider} {...this.slickSettings}>
								{this.renderMainImages()}
							</Slider>
						</React.Fragment>
					: 
						this.state.activeImage != '3d' ?
							<FloatingImage>						
								<img src={activeImage} onClick={() => this.triggerZoomModal()}/>
							</FloatingImage>
							:
							<Part3DViewer id={renderingData.id} color={renderingData.color} onError= {() => this.on3DError()}/>
					}
					
					{wantedListEnabled ? 
						<div className="gallery-card__action">
							<button className="wanted-list-pill pill pill--round gallery-card__wanted" onClick={() => this.toggleAddWantedList()}>
								<i className={"wanted-list-pill__icon l-margin-right--xxs " + (wantedListIsWanted ? "fas fa-heart" : "far fa-heart") + (wantedListIsWanted ? " wanted-list-pill__icon--active" : "")}/>
								{wantedListCount}
							</button>
						</div>
					: null}
					{this.props.likeButton ? 
						<div className="gallery-card__action">
							<LikeButton likes={{liked: this.props.likeButton.liked, count: this.props.likeButton.count}} onClickFunc={this.props.likeButton.likeFunc}/>
						</div>
					: null}
				</div>
				<div ref={thumbnails => this.thumbnails = thumbnails} className="gallery-card__thumbnails">
					{this.renderThumbnails()}
					{renderingData ? 
						<div className={"gallery-card__thumbnails-item gallery-card__thumbnails-item--3d " + (this.state.activeImage == '3d' ? "gallery-card__thumbnails-item--active" : "")} onClick={() => this.setState({activeImage: '3d'})}>
							<i className="fas fa-cube l-block"/>
							<strong>3D Image</strong>
						</div>
					: null}
				</div>
			</article>
		);
	}

	on3DError()
	{
		this.setState({activeImage: 0})
	}

	renderThumbnails() 
	{
		const images 		= this.props.images;
		const thumbnails 	= images.map(
								(image, key) => 
								{
									return (
										<div key={image.id} className={"gallery-card__thumbnails-item " + (image.id == this.state.activeImage ? "gallery-card__thumbnails-item--active" : "")} onClick={() => this.selectImage(image.id)}>
											<FloatingImage>
												<img src={image.small} loading="lazy"/>
											</FloatingImage>
										</div>
									);
								}
							);

		return thumbnails;
	}

	renderMainImages() 
	{
		const images = this.props.images;

		const mainImages = images.map((image, key) => {
			return (
				<FloatingImage key={image.id}>
					<img src={image.large} loading={key != 0 ? "lazy" : "eager"} onMouseDown={(e) => this.setState({position: {x: e.clientX, y: e.clientY}})} onMouseUp={(e) => this.shouldTriggerZoomModal(e)}/>
				</FloatingImage>
			);
		});

		return mainImages;
	}

	selectImage( id ) 
	{
		if(this.props.mode == 1) {
			this.setState({activeImage: id}, () => {if(this.props.onImageChange != null)this.props.onImageChange(this.props.images[id])});
			this.slider.slickGoTo(id);
		}else{
			this.setState({activeImage: id}, () => {if(this.props.onImageChange != null)this.props.onImageChange(this.props.images[id])});
		}
	}

	changeSlide(index) {
		this.setState({activeImage: index}, () => {if(this.props.onImageChange != null)this.props.onImageChange(this.props.images[index])});

		const thumbnails 		= this.thumbnails;
		const activeThumb 	= thumbnails.querySelector('.gallery-card__thumbnails-item--active');
			activeThumb  != null ? thumbnails.scrollLeft = activeThumb.offsetLeft - thumbnails.offsetLeft : 0;
	}

	shouldTriggerZoomModal(e) {
		const prev = this.state.position;

		if(e.clientX == prev.x && e.clientY == prev.y) {
			this.triggerZoomModal();
		}
	}

	triggerZoomModal() 
	{
		blapp.screen.toggleScroll(!this.state.showZoomModal);
		this.setState({showZoomModal: true, images: this.props.images});
	}

	renderZoomModal() 
	{
		const images = this.state.images.map(image => image.large);

		return (
			<ZoomModal data={{images: images, activeImage: this.state.activeImage}} func={{toggleZoomModal: () => {blapp.screen.toggleScroll(!this.state.showZoomModal); this.setState({showZoomModal: false, images: []})}}}/>
		);
	}

	toggleAddWantedList = () =>
	{
		if ( blapp.session.isLoggedIn() ) 
		{
			this.addToWantedList();
		} 
		else 
		{
			blapp.refs.get( "header" ).showLogin(
				() => {
					if ( blapp.session.isLoggedIn() ) {
						this.addToWantedList();
					}
				}
			);			
		}
	}

	addToWantedList()
	{
		blapp.wanted.showAddWantedListModal( 
			this.props.wantedList.dmItemView
		,	() => { blapp.personalized.fetchWantedPrefData( this.props.item.idItem, this.props.item.idColor, this.updatePersonalizedData ); }
		,	( this.props.wantedList.srcMap || { location:	 blapp.srcmap.LOCATION.GENERAL_XP } )
		);
	}

	fetchPersonalizeData()
	{
		if ( ( this.state.wantedListEnabled || this.state.qtyCheckEnabled ) && ( this.props.item && this.props.item.idItem ) )
		{
			this._callbackRegistered	= this.updatePersonalizedData;
			blapp.personalized.fetchPersonalizedData( this.props.item.idItem, this.props.item.idColor, this.updatePersonalizedData, this.state.wantedListEnabled, this.state.qtyCheckEnabled );
		}
	}

	updatePersonalizedData = ( data ) => 
	{
		if ( data && data.dataWantedPref )
		{
			this.setState( { isWanted: data.dataWantedPref.bIsWanted, wantedCnt: data.dataWantedPref.nWantedUserCnt } );
		}
	}
};


GalleryCard.propTypes = 
	{
		classes:		PropTypes.string
	,	active:			PropTypes.number
	,	item:			PropTypes.shape(
							{	
								idItem:		PropTypes.number
							,	idColor:	PropTypes.number 
							}
						)
	,	images:			PropTypes.arrayOf( 
							PropTypes.shape( 
								{
									id:		PropTypes.number
								,	large:	PropTypes.string
								,	small:	PropTypes.string 
								} 
							)
						)
	,	wantedList:		PropTypes.shape(
							{
								enabled:			PropTypes.bool
							,	isWanted:			PropTypes.bool
							,	wantedCount:		PropTypes.number
							,	idItem:				PropTypes.number
							,	idColor:			PropTypes.number
							,	addToWantedList:	PropTypes.func
							,	srcMap:				PropTypes.object
							}
						)
	,	renderingData:	PropTypes.shape(
							{
								id:	PropTypes.string
							}
						)
	,	likeButton:		PropTypes.shape(
							{
								liked:		PropTypes.bool.isRequired
							,	count:		PropTypes.number.isRequired
							,	likeFunc:	PropTypes.func.isRequired
							}
						)
	,	verticalThumbs: PropTypes.bool
	,	onImageChange:	PropTypes.func
	}